/* INTELEVO Start here: a coverflow of featured guides */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initCoverflow(el) {
    if (el._ivCf) return;
    el._ivCf = true;
    const stage = $('.iv-cf__stage', el), items = $$('.iv-cf__item', el), panels = $$('.iv-cf__panel', el), thumbs = $$('.iv-cf__thumb', el);
    const info = $('.iv-cf__info', el), count = $('.iv-cf__count', el);
    const n = items.length;
    if (!n || !stage) return;
    let active = 0, dragX = null, dragged = false;
    function layout() {
      const w = stage.clientWidth, step = Math.min(w * 0.17, 150);
      items.forEach((it, i) => {
        let off = i - active;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        const a = Math.abs(off);
        const x = off * step - Math.sign(off) * Math.max(0, a - 1) * step * 0.38;
        it.style.setProperty('--x', x.toFixed(1) + 'px');
        it.style.setProperty('--z', -a * 150 + 'px');
        it.style.setProperty('--ry', (off === 0 ? 0 : off > 0 ? -34 : 34) + 'deg');
        it.style.setProperty('--s', off === 0 ? 1 : 0.88);
        it.style.setProperty('--o', a > 3 ? 0 : 1);
        it.style.setProperty('--zi', 20 - a);
        it.setAttribute('aria-current', off === 0 ? 'true' : 'false');
        it.tabIndex = off === 0 ? 0 : -1;
      });
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === active ? 'true' : 'false'));
      if (count) count.textContent = `${active + 1} / ${n}`;
    }
    function set(i) {
      const next = ((i % n) + n) % n;
      if (next === active) return;
      active = next;
      if (info && !reduced()) {
        info.classList.add('is-swapping');
        setTimeout(() => { panels.forEach((p, k) => (p.hidden = k !== active)); info.classList.remove('is-swapping'); }, 220);
      } else panels.forEach((p, k) => (p.hidden = k !== active));
      layout();
    }
    items.forEach((it, i) => it.addEventListener('click', (e) => {
      if (dragged) { e.preventDefault(); return; }
      if (i !== active) { e.preventDefault(); set(i); }
    }));
    thumbs.forEach((t, i) => t.addEventListener('click', () => set(i)));
    const prev = $('.iv-cf__prev', el), next = $('.iv-cf__next', el);
    if (prev) prev.addEventListener('click', () => set(active - 1));
    if (next) next.addEventListener('click', () => set(active + 1));
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); set(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); set(active + 1); }
    });
    stage.addEventListener('pointerdown', (e) => { dragX = e.clientX; dragged = false; });
    stage.addEventListener('pointermove', (e) => { if (dragX !== null && Math.abs(e.clientX - dragX) > 8) dragged = true; });
    stage.addEventListener('pointerup', (e) => {
      if (dragX === null) return;
      const dx = e.clientX - dragX; dragX = null;
      if (Math.abs(dx) > 40) set(active + (dx < 0 ? 1 : -1));
      setTimeout(() => (dragged = false), 0);
    });
    stage.addEventListener('pointercancel', () => (dragX = null));
    addEventListener('resize', layout, { passive: true });
    layout();
    el.classList.add('is-ready');
  }
  const init = (scope = document) => $$('[data-iv-coverflow]', scope).forEach(initCoverflow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();